<template>
  <div
    class="tab-pane fade"
    id="temburong"
    role="tabpanel"
    aria-labelledby="temburong-tab"
  >
    <div class="card-body">
      <div class="form-group">
        <label>District</label>
        <input type="text" v-model="district" class="form-control" />
      </div>

      <div class="form-group">
        <div id="app">
          <ckeditor
            :editor="editor"
            v-model="content"
            :config="editorConfig"
          ></ckeditor>
        </div>
      </div>

      <button class="btn btn-primary" @click="updateContent">
        Update
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "workshop_temburong",

  components: {
    ckeditor: CKEditor.component
  },

  data() {
    return {
      content: "",
      district: "",
      editor: ClassicEditor,
      editorConfig: {}
    };
  },

  methods: {
    loadDistrict() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/workshops", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].id === 4) {
                this.district = res.data[i].district;

                if (res.data[i].content === null) {
                  this.content = "";
                } else {
                  this.content = res.data[i].content;
                }
              }
            }
          });
      }
    },

    updateContent() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/workshops/update/" + 4,
            {
              _method: "PATCH",
              content: this.content,
              district: this.district
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.loadDistrict();

            swal({
              text: "Update Successful",
              icon: "success",
              button: "OK"
            });
          });
      }
    }
  },

  mounted() {
    this.loadDistrict();
  }
};
</script>
